import DayPicker from 'react-day-picker';
import { defaultProps } from 'react-recompose';
import 'react-day-picker/lib/style.css';
import './overrides.css';

export default defaultProps({
  todayButton: 'Today',
})(DayPicker);
